export default "__VITE_ASSET__BWHKlIeg__"